export const STATUS_CERTIFICADO = {
  CANCELADO: "Cancelado",
  RECEBIDO: "Recebido",
  SOLICITADO: "Solicitado",
} as const;
